export const CRM_AUTH_PATHS = {
  zoho_crm: "/api/crm/zoho/auth",
};

export const CRM_RECORD_PATHS = {
  zoho_crm: "zoho-crm/Deals/records",
};

export const CRM_ALLOWED_MODULES = {
  zoho_crm: ["Deals"],
};

export const ENABLE_THIRD_PARTY_INTEGRATION_MODAL_CONTENT = {
  zoho_crm: [
    {
      type: "enable_integration",
      modalHeader: "Enable Integration",
      modalBody: "Enable the Zoho CRM integration first to use it as an external data source for proposal creation.",
      modalButton: "Enable Integration",
    },
    {
      type: "only_admin_enable_integration",
      modalHeader: "Enable Integration",
      modalBody: "Enable the Zoho CRM integration first to use it as an external data source for proposal creation.",
      modalButton: "Only Admin can enable",
      disabled: true,
    },
    {
      type: "authorize_dochipo",
      modalHeader: "Authorize",
      modalBody:
        "By granting this authorization, Zoho CRM recognizes DocHipo as a trusted application, enabling it to perform specific actions, while ensuring the security and integrity of your information.",
      modalButton: "Authorize DocHipo",
    },
    {
      type: "user_exists",
      modalHeader: "User Already Linked",
      modalBody:
        "This Zoho CRM user is already linked to a DocHipo account. If this is incorrect, please contact your admin. The current user must disable their integration before you can connect.",
    },
    {
      type: "organization_mismatch",
      modalHeader: "Zoho CRM Organization Mismatch",
      modalBody:
        "Your Zoho CRM account belongs to a different organization than the one connected to this DocHipo company account. Please connect using a user account from the same Zoho CRM organization.",
    },
  ],
};

export const UNAUTHORIZED_ACCESS = "You don’t have permission to access this record";

export const MESSAGE_DISPLAY_TIME = 3000; // 3sec
